import React from 'react';
import InputMask from "react-input-mask";

export const MaskWidget = ({ schema, value, required, onChange }) => {
  const mask = schema?.properties?.mask?.const || '';
  const alwaysShowMask = schema?.properties?.mask?.alwayshowmask ?? true;

  return (
    <InputMask
      mask={mask}
      alwaysShowMask={alwaysShowMask}
      value={value}
      required={required}
      onChange={e => onChange(e.target.value)}
      className="form-control"
    />
  );
};
